import { Button, Stack } from '@mui/material';
import Box from '@mui/material/Box';
import { useGetCurrentUserQuery, useGetSavedSearchesQuery } from '../../api/user.api.ts';

interface FilterDrawerFooterProps {
	onApply: () => void;
	onClear: () => void;
	onSave: () => void;
	filtersSelected: boolean;
}

function FilterDrawerFooter(props: FilterDrawerFooterProps) {
	const { data: user } = useGetCurrentUserQuery();

	const { data: savedSearches } = useGetSavedSearchesQuery(undefined, {
		skip: !user || !user.userId,
	});

	return (
		<>
			<Stack>
				<Box display="flex" gap={1} marginTop={2} justifyContent="flex-end">
					<Box display="flex" alignItems="center" sx={(theme) => ({
						cursor: 'pointer', color: theme.palette.brand.primary
					})}>
						<span data-testid="clear-filters-button"
							style={{
								fontWeight: 'bold',
								fontSize: 13,
							}}
							onClick={props.onClear}
						>
							Clear All
						</span>
					</Box>
					<Box>
						<Button
							variant="outlined"
							color="primary"
							data-testid="save-search-button"
							disabled={!props.filtersSelected || savedSearches?.length === 10}
							sx={{
								fontSize: 13,
								borderRadius: '20px',
							}}
							onClick={props.onSave}
						>
							Save Search
						</Button>
					</Box>
					<Box>
						<Button
							variant="contained"
							data-testid="apply-filters-button"
							color="primary"
							onClick={props.onApply}
							sx={{
								fontSize: 13,
								borderRadius: '20px',
							}}
						>
							Apply Filters
						</Button>
					</Box>
				</Box>
				{savedSearches?.length === 10 && (
					<Box display="flex" justifyContent="center" sx={{ mt: 1 }}>
						Limit of 10 saved searches reached.
					</Box>
				)}
			</Stack>
		</>
	);
}

export default FilterDrawerFooter;
